import React, { Component } from 'react';
import { Tooltip } from 'reactstrap';
import random_id from '../random_id';
import { T, TraksConsumer } from '../traks';
import Butt from './Butt.js';
import { EmailClientSend, FacebookSend, FacebookShare } from '../c/SocialMediaStuff';

const LinkField = (props) => {
	let extra_props = {};
	let width_css = "ad_width_20_rem";
    let css_class_names = "ad_game_link_ro_input";

	if (props.width_css) width_css = props.width_css;

    css_class_names += " " + width_css;
	css_class_names += props.css_classes ? " " + props.css_classes : " mb-3";

	if (props.set_ref) extra_props.ref = props.set_ref;
	if (props.on_click) extra_props.onClick = props.on_click;
	if (props.no_input) {
		return <div className={css_class_names}>{props.url}</div>;
	} else {
		return <input className={css_class_names} value={props.url} {...extra_props} readOnly={true}/>;
	}
};

const ShareURLViaWebShareAPI = (props) => {
	const do_share = () => {
		navigator.share({
			title: props.title || "",
			text: props.text || "",
			url: props.url,
		});
	};
	return (
		<span>
			<LinkField url={props.url} css_classes={props.css_classes} on_click={do_share}/>
			<span className="pl-md-2">
				<Butt className="ad_copy_link_btn align-top px-5" onClick={do_share}><T>Share</T></Butt>
			</span>
		</span>
	);
};

class ShareURLViaExecCommandImpl extends Component {
	constructor(props) {
		super(props);
		this.state = {show_tooltip: false, was_copied: false};
		this.ref = null;
		this.rid = random_id();
	}

	render() {
		const set_ref = (ref) => {
			this.ref = ref;
		}

		const do_select_all = (e) => {
			e.target.select();
		}

		const do_copy = () => {
			if (!this.ref) return;
			this.ref.select();
			document.execCommand("copy");
			this.setState({was_copied: true});
		};

		const toggle = () => {
			this.setState((prev_state) => {
				var new_state = {show_tooltip: !prev_state.show_tooltip};
				if (!new_state.show_tooltip) new_state.was_copied = false;
				return new_state;
			});
		};

		var tooltip;
		if (!this.state.was_copied) {
			tooltip = <T>Copy to clipboard</T>;
		} else {
			tooltip = <T>Copied!</T>;
		}

		tooltip = this.props.render_static(tooltip);

		return (
			<React.Fragment>
				<div className="pb-3">
					<span>
						<LinkField url={this.props.url} css_classes={this.props.css_classes} on_click={do_select_all} set_ref={set_ref}/>
						<span className="pl-md-2" id={this.rid}>
							<Butt className="ad_copy_link_btn align-top" onClick={do_copy}><T>Copy link</T></Butt>
							<Tooltip placement="bottom" isOpen={this.state.show_tooltip} target={this.rid} toggle={toggle}>
								{tooltip}
							</Tooltip>
						</span>
					</span>
				</div>
				<FacebookShare url={this.props.url}/><span className="pr-2"/>
				<FacebookSend url={this.props.url}/><span className="pr-2"/>
				<EmailClientSend url={this.props.url}/>
			</React.Fragment>
		);
	}
}

const ShareURLViaExecCommand = (props) => <TraksConsumer><ShareURLViaExecCommandImpl {...props}/></TraksConsumer>;

const ShareURLFallback = (props) => {
	return (
		<React.Fragment>
			<div className="pb-3">
				<span>
					<LinkField url={props.url} no_input={true} css_classes={props.css_classes} />
				</span>
			</div>
			<FacebookShare url={props.url}/><span className="pr-2"/>
			<FacebookSend url={props.url}/><span className="pr-2"/>
			<EmailClientSend url={props.url}/>
		</React.Fragment>
	);
};

const ShareURL = (props) => {
	var method = props.method;

	if (method === undefined && navigator.share) method = "share";
	if (method === undefined && document.queryCommandSupported && document.queryCommandSupported("copy")) method = "copy";

	switch (method) {
	case "share": return <ShareURLViaWebShareAPI {...props}/>;
	case "copy": return <ShareURLViaExecCommand {...props}/>;
	default: return <ShareURLFallback {...props}/>;
	}
};

export { ShareURL, LinkField };



// WEBPACK FOOTER //
// ./src/c/ShareURL.js